/* eslint-disable max-lines -- a lot of icons will go away with objectless and there is no complexity to this file */
import { CustomIconDefinition } from '../../../cross-team-shared/icons/register-custom-icons';
import { complexObjectIcon } from './complex-object-icon';
import { flagTechnicalIssueIcon } from './debug-logging/flag-technical-issue-icon';
import { startDebugLoggingIcon } from './debug-logging/start-debug-logging-icon';
import { addFeedbackIcon } from './feedback/add-feedback-icon';
import { edgeCaseFeedbackIcon } from './feedback/edge-case-feedback-icon';
import { extraShapeFeedbackIcon } from './feedback/extra-shape-feedback-icon';
import { inaccurateShapeFeedbackIcon } from './feedback/inaccurate-shape-feedback-icon';
import { incorrectAttributeFeedbackIcon } from './feedback/incorrect-attribute-feedback-icon';
import { incorrectLabelFeedbackIcon } from './feedback/incorrect-label-feedback-icon';
import { instructionGapFeedbackIcon } from './feedback/instruction-gap-feedback-icon';
import { missingShapeFeedbackIcon } from './feedback/missing-shape-feedback-icon';
import { otherFeedbackIcon } from './feedback/other-feedback-icon';
import { sensorIssueFeedbackIcon } from './feedback/sensor-issue-feedback-icon';
import { subjectivityFeedbackIcon } from './feedback/subjectivity-feedback-icon';
import { finalizeSampleIcon } from './finalize-sample-icon';
import { objectIcon } from './object-icon';
import { projectionIndicatorIcon } from './output-tabs/projection-indicator-icon';
import { pauseTaskIcon } from './pause-task-icon';
import { samaIcons } from './sama-icons';
import { arrowShapeTypeIcon } from './shape-types/arrow-shape-type-icon';
import { cuboidShapeTypeIcon } from './shape-types/cuboid-shape-type-icon';
import { keypointShapeTypeIcon } from './shape-types/keypoint-shape-type-icon';
import { lineShapeTypeIcon } from './shape-types/line-shape-type-icon';
import { pointShapeTypeIcon } from './shape-types/point-shape-type-icon';
import { polygonShapeTypeIcon } from './shape-types/polygon-shape-type-icon';
import { rectangleShapeTypeIcon } from './shape-types/rectangle-shape-type-icon';
import { sliderRectangleShapeTypeIcon } from './shape-types/slider-rectangle-shape-type-icon';
import { dashboardIcon } from './side-panel/dashboard-icon';
import { evenSplitIcon } from './side-panel/even-split-icon';
import { imageIcon } from './side-panel/image-icon';
import { regionOfInterestIcon } from './side-panel/region-of-interest-icon';
import { resetIcon } from './side-panel/reset-icon';
import { settingsIcon } from './side-panel/settings-icon';
import { unevenSplitIcon } from './side-panel/uneven-split-icon';
import { submitTaskIcon } from './submit-task-icon';
import { addModeIcon } from './toolbars/add-mode-icon';
import { arrowIcon } from './toolbars/arrow-icon';
import { calibrationSettingsIcon } from './toolbars/calibration-settings-icon';
import { cuboidIcon } from './toolbars/cuboid-icon';
import { dragModeIcon } from './toolbars/drag-mode-icon';
import { editIcon } from './toolbars/edit-icon';
import { enhancedPointCloudIcon } from './toolbars/enhanced-point-cloud-icon';
import { faceOfInterestModeIcon } from './toolbars/face-of-interest-mode-icon';
import { freePointModeIcon } from './toolbars/free-point-mode-icon';
import { inspectModeIcon } from './toolbars/inspect-icon';
import { keyboardShortcutsIcon } from './toolbars/keyboard-shortcuts-icon';
import { keypointIcon } from './toolbars/keypoint-icon';
import { lineIcon } from './toolbars/line-icon';
import { measureIcon } from './toolbars/measure-icon';
import { pointCloudProjectionIcon } from './toolbars/point-cloud-projection-icon';
import { pointIcon } from './toolbars/point-icon';
import { polygonIcon } from './toolbars/polygon-icon';
import { rectangleIcon } from './toolbars/rectangle-icon';
import { removeModeIcon } from './toolbars/remove-mode-icon';
import { resetZoomIcon } from './toolbars/reset-zoom-icon';
import { rotateCuboidModeIcon } from './toolbars/rotate-cuboid-mode-icon';
import { shapeProjectionIcon } from './toolbars/shape-projection-icon';
import { sliderRectangleIcon } from './toolbars/slider-rectangle-icon';
import { splitViewIcon } from './toolbars/split-view-icon';
import { subpointModeIcon } from './toolbars/subpoint-mode-icon';
import { toggleGroundIcon } from './toolbars/toggle-ground-icon';
import { toggleIcon } from './toolbars/toggle-icon';
import { toggleRouteIcon } from './toolbars/toggle-route-icon';
import { topViewIcon } from './toolbars/top-view-icon';
import { translateModeIcon } from './toolbars/translate-mode-icon';
import { viewAllIcon } from './toolbars/view-all-icon';
import { viewNoneIcon } from './toolbars/view-none-icon';
import { viewSelectedIcon } from './toolbars/view-selected-icon';
import { zoomPanelIcon } from './toolbars/zoom-panel-icon';

export const stepBackward: CustomIconDefinition = {
  prefix: 'ursa',
  iconName: 'step-backward',
  icon: [
    24,
    24,
    [],
    '',
    'M9.07628 10.3513L14.926 4.39811C15.7142 3.59593 17.2095 4.08724 17.2095 5.14843L17.2095 18.8516C17.2095 19.9128 15.7142 20.4041 14.926 19.6019L9.07628 13.6487L9.07628 19.7C9.07628 19.8657 8.94197 20 8.77628 20L7.09057 20C6.92488 20 6.79056 19.8657 6.79056 19.7L6.79057 4.3C6.79057 4.13431 6.92488 4 7.09057 4L8.77628 4C8.94197 4 9.07628 4.13431 9.07628 4.3L9.07628 10.3513Z',
  ],
};

export const fastBackward: CustomIconDefinition = {
  prefix: 'ursa',
  iconName: 'fast-backward',
  icon: [
    24,
    24,
    [],
    '',
    'M12.9089 9.77699L17.065 5.44047C17.733 4.74353 19 5.17039 19 6.09235V17.9977C19 18.9197 17.733 19.3466 17.065 18.6496L12.9089 14.3131L12.9089 17.9077C12.9089 18.8296 11.6419 19.2565 10.974 18.5595L5.26895 12.6068C4.91034 12.2327 4.91034 11.6773 5.26895 11.3031L10.974 5.35038C11.6419 4.65344 12.9089 5.0803 12.9089 6.00226L12.9089 9.77699Z',
  ],
};

export const skipBackward: CustomIconDefinition = {
  prefix: 'ursa',
  iconName: 'skip-backward',
  icon: [
    24,
    24,
    [],
    '',
    'M10.2625 6C10.0968 6 9.96252 6.13432 9.96252 6.3L9.96252 17.7C9.96252 17.8657 10.0968 18 10.2625 18H11.6625C11.8282 18 11.9625 17.8657 11.9625 17.7V12.9561L16.004 16.7263C16.5952 17.2778 17.7166 16.94 17.7166 16.2105V13.889L20.758 16.7263C21.3492 17.2778 22.4706 16.94 22.4706 16.2105L22.4706 6.78954C22.4706 6.05998 21.3492 5.7222 20.758 6.2737L17.7166 9.111V6.78954C17.7166 6.05998 16.5952 5.7222 16.004 6.2737L11.9625 10.0439V6.3C11.9625 6.13432 11.8282 6 11.6625 6H10.2625ZM4.1323 14.8485L2.05656 12.7728C1.35362 12.0698 1.35362 10.9301 2.05656 10.2272L4.1323 8.15147C4.83524 7.44853 5.97494 7.44853 6.67788 8.15147L8.75362 10.2272C9.45656 10.9302 9.45656 12.0699 8.75362 12.7728L6.67788 14.8485C5.97494 15.5515 4.83524 15.5515 4.1323 14.8485ZM5.19296 13.7879C5.31012 13.905 5.50006 13.905 5.61722 13.7879L7.69296 11.7121C7.81012 11.595 7.81012 11.405 7.69296 11.2879L5.61722 9.21213C5.50006 9.09497 5.31012 9.09497 5.19296 9.21213L3.11722 11.2879C3.00006 11.405 3.00006 11.595 3.11722 11.7121L5.19296 13.7879Z',
  ],
};

export const stepForward: CustomIconDefinition = {
  prefix: 'ursa',
  iconName: 'step-forward',
  icon: [
    24,
    24,
    [],
    '',
    'M14.9237 13.6487L9.07399 19.6019C8.28575 20.4041 6.79053 19.9128 6.79053 18.8516L6.79053 5.14842C6.79053 4.08724 8.28576 3.59593 9.07399 4.39811L14.9237 10.3513V4.3C14.9237 4.13432 15.058 4 15.2237 4H16.9094C17.0751 4 17.2094 4.13432 17.2094 4.3L17.2094 19.7C17.2094 19.8657 17.0751 20 16.9094 20H15.2237C15.058 20 14.9237 19.8657 14.9237 19.7V13.6487Z',
  ],
};

export const fastForward: CustomIconDefinition = {
  prefix: 'ursa',
  iconName: 'fast-forward',
  icon: [
    24,
    24,
    [],
    '',
    'M11.0911 14.223L6.93497 18.5595C6.26703 19.2565 5 18.8296 5 17.9077L5 6.00226C5 5.0803 6.26704 4.65344 6.93498 5.35038L11.0911 9.68691L11.0911 6.09235C11.0911 5.17039 12.3581 4.74353 13.026 5.44047L18.7311 11.3932C19.0897 11.7673 19.0897 12.3227 18.7311 12.6969L13.026 18.6496C12.3581 19.3466 11.0911 18.9197 11.0911 17.9977L11.0911 14.223Z',
  ],
};

export const skipForward: CustomIconDefinition = {
  prefix: 'ursa',
  iconName: 'skip-forward',
  icon: [
    24,
    24,
    [],
    '',
    'M13.7375 18C13.9032 18 14.0375 17.8657 14.0375 17.7L14.0375 6.3C14.0375 6.13431 13.9032 6 13.7375 6H12.3375C12.1718 6 12.0375 6.13431 12.0375 6.3L12.0375 11.0439L7.99598 7.2737C7.40481 6.7222 6.28339 7.05998 6.28339 7.78954L6.28339 10.111L3.24195 7.2737C2.65078 6.7222 1.52936 7.05998 1.52936 7.78954L1.52936 17.2105C1.52936 17.94 2.65078 18.2778 3.24195 17.7263L6.28339 14.889L6.28339 17.2105C6.28339 17.94 7.4048 18.2778 7.99598 17.7263L12.0375 13.9561L12.0375 17.7C12.0375 17.8657 12.1718 18 12.3375 18L13.7375 18ZM19.8677 9.15147L21.9434 11.2272C22.6464 11.9302 22.6464 13.0699 21.9434 13.7728L19.8677 15.8485C19.1648 16.5515 18.0251 16.5515 17.3221 15.8485L15.2464 13.7728C14.5434 13.0698 14.5434 11.9301 15.2464 11.2272L17.3221 9.15147C18.0251 8.44853 19.1648 8.44853 19.8677 9.15147ZM18.807 10.2121C18.6899 10.095 18.4999 10.095 18.3828 10.2121L16.307 12.2879C16.1899 12.405 16.1899 12.595 16.307 12.7121L18.3828 14.7879C18.4999 14.905 18.6899 14.905 18.807 14.7879L20.8828 12.7121C20.9999 12.595 20.9999 12.405 20.8828 12.2879L18.807 10.2121Z',
  ],
};

export const play: CustomIconDefinition = {
  prefix: 'ursa',
  iconName: 'play',
  icon: [
    24,
    24,
    [],
    '',
    'M16.4735 11.2497C16.9088 11.6804 16.9088 12.3196 16.4735 12.7503L9.54869 19.6019C8.73793 20.4041 7.19999 19.9128 7.19999 18.8516L7.19999 5.14842C7.19999 4.08724 8.73794 3.59593 9.54869 4.39811L16.4735 11.2497Z',
  ],
};

export const pause: CustomIconDefinition = {
  prefix: 'ursa',
  iconName: 'pause',
  icon: [
    24,
    24,
    [],
    '',
    'M7 19C6.44772 19 6 18.5523 6 18V6C6 5.44772 6.44772 5 7 5H9C9.55228 5 10 5.44772 10 6V18C10 18.5523 9.55228 19 9 19H7ZM14 6C14 5.44772 14.4477 5 15 5H17C17.5523 5 18 5.44772 18 6V18C18 18.5523 17.5523 19 17 19H15C14.4477 19 14 18.5523 14 18V6Z',
  ],
};

export const customMaterialIcons = [
  {
    svg: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="#232426" fill-opacity="0.87"/>
</svg>
`,
    name: 'expand',
  },
  {
    svg: `<svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.4303 8.04224C0.833787 7.32335 0.348269 6.50876 0 5.625C0.774943 3.65853 2.22943 2.0345 4.07425 1.04534L3.11885 3.5737C2.52042 4.15623 2.01616 4.8465 1.635 5.625C1.76289 5.8862 1.90464 6.13747 2.05915 6.37808L1.4303 8.04224ZM9.24788 0.0556422C8.92034 0.0188806 8.58739 0 8.25 0C7.77439 0 7.30758 0.0375201 6.85236 0.10976L6.22099 1.7806C6.86883 1.59685 7.55009 1.5 8.25 1.5C8.39993 1.5 8.54901 1.50444 8.69709 1.51324L9.24788 0.0556422ZM8.41714 2.25409C8.36176 2.25137 8.30604 2.25 8.25 2.25C7.12581 2.25 6.12764 2.80344 5.51384 3.65199L4.89036 5.30195C4.8802 5.4083 4.875 5.51606 4.875 5.625C4.875 6.69064 5.37229 7.64304 6.14684 8.26216L6.72908 6.72134C6.50631 6.41296 6.375 6.03422 6.375 5.625C6.375 4.73282 6.99917 3.98553 7.83438 3.79629L8.41714 2.25409ZM5.74796 9.31774C5.03714 9.06293 4.37343 8.70079 3.77803 8.2456L3.23198 9.69065C3.84331 10.1121 4.51006 10.4587 5.21912 10.7172L5.74796 9.31774ZM13.4348 1.67718C12.8311 1.24022 12.1704 0.877527 11.4658 0.602535L10.9372 2.00146C11.643 2.27623 12.2994 2.65811 12.8848 3.1326L13.4348 1.67718ZM10.5175 9.39735L9.87362 11.1014C9.34732 11.199 8.80465 11.25 8.25 11.25C7.98227 11.25 7.71733 11.2381 7.45567 11.2148L8.01063 9.74621C8.09016 9.74873 8.16996 9.75 8.25 9.75C9.03636 9.75 9.79919 9.62774 10.5175 9.39735ZM14.865 5.625C14.5603 6.24727 14.177 6.81316 13.7298 7.31273L12.6936 10.055C14.4112 9.05583 15.763 7.4953 16.5 5.625C16.1802 4.81345 15.7446 4.06023 15.2137 3.38588L14.572 5.08392C14.6764 5.2591 14.7742 5.43955 14.865 5.625ZM11.625 5.625C11.625 4.63461 11.1955 3.74204 10.513 3.12391L9.90269 4.73909C10.0445 5.00296 10.125 5.30464 10.125 5.625C10.125 6.43012 9.6167 7.11724 8.90372 7.38275L8.2927 8.99973C10.1331 8.97676 11.625 7.47075 11.625 5.625Z" fill="#232426" fill-opacity="0.87"/>
</svg>`,
    name: 'occluded',
  },
  {
    svg: `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.75 9C2.0475 5.7075 5.25 3.375 9 3.375C12.75 3.375 15.9525 5.7075 17.25 9C15.9525 12.2925 12.75 14.625 9 14.625C5.25 14.625 2.0475 12.2925 0.75 9ZM15.615 9C14.3775 6.4725 11.8425 4.875 9 4.875C6.1575 4.875 3.6225 6.4725 2.385 9C3.6225 11.5275 6.1575 13.125 9 13.125C11.8425 13.125 14.3775 11.5275 15.615 9ZM9 7.125C10.035 7.125 10.875 7.965 10.875 9C10.875 10.035 10.035 10.875 9 10.875C7.965 10.875 7.125 10.035 7.125 9C7.125 7.965 7.965 7.125 9 7.125ZM5.625 9C5.625 7.14 7.14 5.625 9 5.625C10.86 5.625 12.375 7.14 12.375 9C12.375 10.86 10.86 12.375 9 12.375C7.14 12.375 5.625 10.86 5.625 9Z" fill="#232426" fill-opacity="0.87"/>
</svg>`,
    name: 'visible',
  },
  {
    svg: `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M3.5175 4.89373L1.5075 2.88373L2.565 1.81873L15.8625 15.1237L14.805 16.1812L12.24 13.6162C11.235 14.0137 10.14 14.2312 9 14.2312C5.25 14.2312 2.0475 11.8987 0.75 8.60623C1.3275 7.12873 2.295 5.85373 3.5175 4.89373ZM9 4.48123C11.8425 4.48123 14.3775 6.07873 15.615 8.60623C15.1725 9.52123 14.55 10.3087 13.8075 10.9462L14.865 12.0037C15.9075 11.0812 16.7325 9.92623 17.25 8.60623C15.9525 5.31373 12.75 2.98123 9 2.98123C8.0475 2.98123 7.1325 3.13123 6.27 3.40873L7.5075 4.64623C7.995 4.54873 8.49 4.48123 9 4.48123ZM8.1975 5.33623L9.75 6.88873C10.1775 7.07623 10.5225 7.42123 10.71 7.84873L12.2625 9.40123C12.3225 9.14623 12.3675 8.87623 12.3675 8.59873C12.375 6.73873 10.86 5.23123 9 5.23123C8.7225 5.23123 8.46 5.26873 8.1975 5.33623ZM7.1325 8.50873L9.09 10.4662C9.06 10.4737 9.03 10.4812 9 10.4812C7.965 10.4812 7.125 9.64123 7.125 8.60623C7.125 8.58748 7.12687 8.57248 7.12875 8.55748L7.12875 8.55747C7.13063 8.54247 7.1325 8.52747 7.1325 8.50873ZM5.895 7.27123L4.5825 5.95873C3.675 6.64873 2.91 7.53373 2.385 8.60623C3.6225 11.1337 6.1575 12.7312 9 12.7312C9.7125 12.7312 10.4025 12.6262 11.0625 12.4462L10.3275 11.7112C9.9225 11.8837 9.4725 11.9812 9 11.9812C7.14 11.9812 5.625 10.4662 5.625 8.60623C5.625 8.13373 5.7225 7.68373 5.895 7.27123Z" fill="#232426" fill-opacity="0.87"/>
</svg>`,
    name: 'invisible',
  },
  {
    svg: `
<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_14_350)">
<mask id="mask0_14_350" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="-1" y="-1" width="11" height="11">
<path d="M9.95837 -0.0413818H-0.041626V9.95862H9.95837V-0.0413818Z" fill="white"/>
<path d="M4.95792 1.7514L8.16446 4.95897L4.95792 8.16654L1.75137 4.95897L4.95792 1.7514Z" fill="black"/>
</mask>
<g mask="url(#mask0_14_350)">
<path d="M4.95792 1.7514L8.16446 4.95897L4.95792 8.16654L1.75137 4.95897L4.95792 1.7514Z" fill="white"/>
<path d="M4.95792 1.75141L5.66514 1.04441C5.47759 0.856805 5.22319 0.751404 4.95792 0.751404C4.69264 0.751404 4.43824 0.856805 4.2507 1.04441L4.95792 1.75141ZM8.16446 4.95898L8.87168 5.66597C9.26205 5.27547 9.26205 4.64248 8.87168 4.25198L8.16446 4.95898ZM4.95792 8.16655L4.2507 8.87354C4.43824 9.06115 4.69264 9.16655 4.95792 9.16655C5.22319 9.16655 5.47759 9.06115 5.66514 8.87354L4.95792 8.16655ZM1.75137 4.95898L1.04415 4.25198C0.65378 4.64248 0.65378 5.27547 1.04415 5.66597L1.75137 4.95898ZM4.2507 2.4584L7.45724 5.66597L8.87168 4.25198L5.66514 1.04441L4.2507 2.4584ZM7.45724 4.25198L4.2507 7.45955L5.66514 8.87354L8.87168 5.66597L7.45724 4.25198ZM5.66514 7.45955L2.45859 4.25198L1.04415 5.66597L4.2507 8.87354L5.66514 7.45955ZM2.45859 5.66597L5.66514 2.4584L4.2507 1.04441L1.04415 4.25198L2.45859 5.66597Z" fill="white"/>
</g>
</g>
<defs>
<clipPath id="clip0_14_350">
<rect width="10" height="10" fill="white"/>
</clipPath>
</defs>
</svg>
`,
    name: 'dynamicFrame',
  },
  {
    svg: `
<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="-1 -1 10 10" >
  <path id="Union" d="M4.67249 0.278551C4.49416 0.100201 4.25225 0 4 0C3.74775 0 3.50584 0.100201 3.32751 0.278551L0.278405 3.32788C-0.0928015 3.69912 -0.0928015 4.30088 0.278405 4.67212L3.32751 7.72145C3.50584 7.8998 3.74775 8 4 8C4.25225 8 4.49416 7.8998 4.67249 7.72145L7.72159 4.67212C8.0928 4.30088 8.0928 3.69912 7.72159 3.32788L4.67249 0.278551Z" fill-opacity="0.87"/>
</svg>
    `,
    name: 'dynamicTag',
  },
  {
    svg: `
<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_14_348)">
<path d="M8 4C8 6.20914 6.20914 8 4 8C1.79086 8 0 6.20914 0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_14_348">
<rect width="8" height="8" fill="white"/>
</clipPath>
</defs>
</svg>
`,
    name: 'keyLocation',
  },
  addFeedbackIcon,
  {
    svg: `<svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 6L6 5L0 0H14L8 5L7 6Z" fill="#232426" fill-opacity="0.87"/>
    <path d="M7 6L6 5V24H8V5L7 6Z" fill="#232426" fill-opacity="0.87"/>
    </svg>`,
    name: 'timelineCursor',
  },
  complexObjectIcon,
  edgeCaseFeedbackIcon,
  instructionGapFeedbackIcon,
  otherFeedbackIcon,
  sensorIssueFeedbackIcon,
  subjectivityFeedbackIcon,
  missingShapeFeedbackIcon,
  extraShapeFeedbackIcon,
  inaccurateShapeFeedbackIcon,
  incorrectAttributeFeedbackIcon,
  incorrectLabelFeedbackIcon,
  objectIcon,
  arrowShapeTypeIcon,
  cuboidShapeTypeIcon,
  keypointShapeTypeIcon,
  lineShapeTypeIcon,
  pointCloudProjectionIcon,
  pointShapeTypeIcon,
  polygonShapeTypeIcon,
  rectangleShapeTypeIcon,
  sliderRectangleShapeTypeIcon,
  startDebugLoggingIcon,
  flagTechnicalIssueIcon,
  samaIcons,
  shapeProjectionIcon,
  splitViewIcon,
  inspectModeIcon,
  rotateCuboidModeIcon,
  faceOfInterestModeIcon,
  viewAllIcon,
  viewNoneIcon,
  viewSelectedIcon,
  toggleIcon,
  freePointModeIcon,
  subpointModeIcon,
  dragModeIcon,
  addModeIcon,
  removeModeIcon,
  arrowIcon,
  cuboidIcon,
  keypointIcon,
  lineIcon,
  pointIcon,
  polygonIcon,
  rectangleIcon,
  sliderRectangleIcon,
  measureIcon,
  editIcon,
  translateModeIcon,
  settingsIcon,
  imageIcon,
  dashboardIcon,
  evenSplitIcon,
  unevenSplitIcon,
  resetIcon,
  toggleRouteIcon,
  toggleGroundIcon,
  topViewIcon,
  resetZoomIcon,
  zoomPanelIcon,
  enhancedPointCloudIcon,
  calibrationSettingsIcon,
  keyboardShortcutsIcon,
  submitTaskIcon,
  pauseTaskIcon,
  regionOfInterestIcon,
  finalizeSampleIcon,
  projectionIndicatorIcon,
  {
    svg: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
     <path fill-rule="evenodd" clip-rule="evenodd" d="M10.881 2.062C11.2487 2.02101 11.6221 2 12 2C12.3779 2 12.7513 2.02101 13.119 2.06199L12.8974 4.04968C12.6032 4.01688 12.3037 4 12 4C11.6963 4 11.3968 4.01688 11.1026 4.04968L10.881 2.062ZM14.7689 2.38858C15.4965 2.59782 16.1898 2.88732 16.8387 3.24671L15.8697 4.99629C15.3509 4.70893 14.797 4.47772 14.2161 4.31065L14.7689 2.38858ZM7.1613 3.24671C7.8102 2.88732 8.50354 2.59782 9.23106 2.38858L9.78388 4.31065C9.20304 4.47772 8.64915 4.70893 8.13031 4.99629L7.1613 3.24671ZM18.2355 4.18177C18.8202 4.64866 19.3513 5.17975 19.8182 5.76445L18.2554 7.01242C17.8814 6.54409 17.4559 6.11861 16.9876 5.74464L18.2355 4.18177ZM4.18177 5.76445C4.64866 5.17976 5.17975 4.64866 5.76445 4.18177L7.01242 5.74464C6.54409 6.11861 6.11861 6.54409 5.74464 7.01242L4.18177 5.76445ZM20.7533 7.1613C21.1127 7.8102 21.4022 8.50354 21.6114 9.23106L19.6893 9.78388C19.5223 9.20304 19.2911 8.64915 19.0037 8.13031L20.7533 7.1613ZM2.38858 9.23106C2.59782 8.50354 2.88732 7.8102 3.24671 7.16131L4.99629 8.13031C4.70893 8.64915 4.47772 9.20304 4.31065 9.78388L2.38858 9.23106ZM21.938 10.881C21.979 11.2487 22 11.6221 22 12C22 12.3779 21.979 12.7513 21.938 13.119L19.9503 12.8974C19.9831 12.6032 20 12.3037 20 12C20 11.6963 19.9831 11.3968 19.9503 11.1026L21.938 10.881ZM2 12C2 11.6221 2.02101 11.2487 2.06199 10.881L4.04968 11.1026C4.01688 11.3968 4 11.6963 4 12C4 12.3037 4.01688 12.6032 4.04968 12.8974L2.062 13.119C2.02101 12.7513 2 12.3779 2 12ZM21.6114 14.7689C21.4022 15.4965 21.1127 16.1898 20.7533 16.8387L19.0037 15.8697C19.2911 15.3509 19.5223 14.797 19.6893 14.2161L21.6114 14.7689ZM3.24671 16.8387C2.88732 16.1898 2.59782 15.4965 2.38858 14.7689L4.31065 14.2161C4.47772 14.797 4.70893 15.3509 4.99629 15.8697L3.24671 16.8387ZM19.8182 18.2355C19.3513 18.8202 18.8202 19.3513 18.2355 19.8182L16.9876 18.2554C17.4559 17.8814 17.8814 17.4559 18.2554 16.9876L19.8182 18.2355ZM5.76445 19.8182C5.17976 19.3513 4.64866 18.8202 4.18177 18.2355L5.74464 16.9876C6.11861 17.4559 6.54409 17.8814 7.01242 18.2554L5.76445 19.8182ZM9.23106 21.6114C8.50354 21.4022 7.8102 21.1127 7.16131 20.7533L8.13031 19.0037C8.64915 19.2911 9.20304 19.5223 9.78388 19.6893L9.23106 21.6114ZM16.8387 20.7533C16.1898 21.1127 15.4965 21.4022 14.7689 21.6114L14.2161 19.6893C14.797 19.5223 15.3509 19.2911 15.8697 19.0037L16.8387 20.7533ZM12 22C11.6221 22 11.2487 21.979 10.881 21.938L11.1026 19.9503C11.3968 19.9831 11.6963 20 12 20C12.3037 20 12.6032 19.9831 12.8974 19.9503L13.119 21.938C12.7513 21.979 12.3779 22 12 22Z" fill="#232426" fill-opacity="0.38"/>
     <path fill-rule="evenodd" clip-rule="evenodd" d="M10.3946 16.8364L6.87695 12.9898L8.35287 11.6401L10.5222 14.0124L15.9683 9.04297L17.3164 10.5203L10.3946 16.8364Z" fill="#232426" fill-opacity="0.38"/>
     </svg>
    `,
    name: 'markAsSolution',
  },
  {
    svg: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" stroke="#13B152" stroke-width="2"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.3946 16.8364L6.87695 12.9898L8.35287 11.6401L10.5222 14.0124L15.9683 9.04297L17.3164 10.5203L10.3946 16.8364Z" fill="#13B152"/>
    </svg>
    `,
    name: 'solvedMarker',
  },
];
